<template>
  <div class="fileModel">
    <div class="content">
      <el-form :model="form">
        <el-form-item label="文件类型*：" label-width="120px">
          <el-select
            style="width: 250px"
            popper-class="my-select"
            v-model="form.fileType"
            placeholder="请选择文件类型"
            @change="addSelect"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件*：" label-width="120px">
          <el-upload
            class="upload-demo filesupload"
            :action="uploadUrl"
            :http-request="myupload"
            :on-change="handleChange"
            :file-list="fileList"
            :before-upload="beforeUpload"
            :multiple="false"
          >
          <!-- :auto-upload="false" -->
            <div v-if="!loading" class="btn item-btn">选择文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="row-item footer"
      style="width: 97%; margin-top: 10px; text-align: center"
    >
      <div class="element-list jb-bg btn" @click="affirm">确认</div>
      <div class="element-list btn" @click="cancel">取消</div>
    </div>
  </div>
</template>

<script>
import { getByType, fileUpload, delFile } from "@/api/depotApi";
import axios from '@/util/request';
export default {
  data() {
    return {
      form: {
        fileType: "",
        typeName: "",
      },
      options: [],
      fileData:{},
      uploadUrl: "/admin/sys-file/upload", //上传地址
      loading: false,
      percentage: 0, //加载进度条初始值
      colors: [
        { color: "#f56c6c", percentage: 20 },
        { color: "#e6a23c", percentage: 40 },
        { color: "#5cb87a", percentage: 60 },
        { color: "#1989fa", percentage: 80 },
        { color: "#6f7ad3", percentage: 100 },
      ],
      fileList: [],
    };
  },
  mounted() {
    this.accessType();
  },
  methods: {
    beforeUpload(file){
      return new Promise((resolve,reject) => {
        const isImage = file.type.includes("image");
      const isLt10M = file.size / 1024 / 1024 < 10;
      const isLt20M = file.size / 1024 / 1024 < 20;
      console.log(isImage,file.type,111)
      if(isImage&&!isLt10M){
        this.$message.error("请选择10m以下图片进行上传");
        return  reject(false)
      }
      if(!isImage&&!isLt20M){
        this.$message.error("请选择20m以下文件进行上传");
        return  reject(false)
      }
      return  resolve(true)
      })
     
      
    },
    accessType() {
      //获取文件类型
      getByType('file_upload_types').then((res) => {
        if (res.code == 200) {
          this.options = res.data;
        }
      });
    },
    addSelect(val) {
      let obj = {};
      obj = this.options.find((item) => {
        return item.id == val;
      });
      this.form.typeName = obj.label;
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    myupload(item) {
      const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      let that = this;
      const form = new FormData();
      let fileObj = item.file;
      form.append("file", fileObj);
      axios({
        url: that.uploadUrl,
        headers: { 'Content-Type': 'multipart/form-data' },
        method: 'post',
        data: form
      }).then(res => {
        loading.close();
        if (res.succeed) {
          this.fileData = {
            fileName: that.fileList[0].name,
            filePath: res.data.fileName,
            typeId: that.form.fileType,
            typeName: that.form.typeName,
          };
        
        }
        else {
          that.$message.error(res.msg);
        }
      }).catch((data) => {
        loading.close();
        that.$message.error("上传失败,请重新上传图片!");
      });
    },
    affirm() {
      if (this.form.fileType == "") {
        this.$message.error("请选择文件类型");
        return;
      }
      if (this.fileList.length == 0) {
        this.$message.error("请选择需要上传的文件");
        return;
      }
      this.$emit("fileChange", this.fileData );
      // this.myupload(this.fileList[0].raw);
    },
    cancel() {
      // delFile({ fileName: this.fileItem }).then((res) => {
      //   if (res.code == "200") {
      //   }
      // });
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="less" scopde>
.fileModel {
  color: #74c8fe;
  .row-item {
    margin-left: 2%;
    display: flex;
  }
  .btn {
    width: 150px;
    border: 2px solid #0090f0;
    border-radius: 6px;
    height: 30px;
    line-height: 30px;
    margin: 0 10px;
    text-align: center;
    cursor: pointer;
  }
  .jb-bg {
    background-image: linear-gradient(#0479b4, #02407e);
  }
  .footer {
    display: flex;
    justify-content: center;
  }
  .content {
    width: 95%;
    .item-btn {
      width: 250px;
      height: 36px;
      line-height: 36px;
      margin: 0;
    }
    /deep/ .el-form-item__label {
      color: #74c8fe;
    }
    /deep/ .el-input__inner {
      border: 2px solid #0090f0;
      color: #74c8fe;
      background-color: transparent !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/files/index.vue